module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00342.4abf55ab.jpg";